export default {
    title: "代表……下令",
    model: {
        email: {
            label: "电子邮件",
            placeholder: "请填写用户名或邮箱",
            notFound: "未找到用户",
            errors: {
                myself: "电子邮件必须与您的电子邮件地址不同"
            }
        }
    },
    cta: {
        impersonate: {
            cta: "提交",
            processing: "提交"
        }
    },
    error: {
        userNotExists: "{email} 不存在",
        country: {
            default: "OI目前在用户所在国家/地区不可用",
            ALPHA3: ""
        }
    }
}